<div class="estoque-consolidado container-fluid">
  <h3><Strong>Estoque Consolidado</Strong></h3>
  <mat-card>
    <mat-card-header class="header-padrao">
      <mat-card-title>
        <form class="d-flex align-items-center filtros-header" [formGroup]="filterForm" (change)="paging.index = 0; listarEstoqueConsolidado()">
          <mat-form-field>
            <mat-label>Filial</mat-label>
            <mat-select formControlName="branch" (selectionChange)="paging.index = 0; listarEstoqueConsolidado()">
              <mat-option selected value='Todas'>Todas</mat-option>
              <mat-option *ngFor="let filial of branches" [value]="filial?.filialID">
                {{ filial?.descricao }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          &nbsp;&nbsp;
          <mat-form-field>
            <mat-label>Cliente</mat-label>
            <input matInput disabled [value]="customer || '-'">
          </mat-form-field>
          &nbsp;&nbsp;
          <mat-form-field>
            <mat-label>Produto</mat-label>
            <input matInput disabled [value]="product || '-'">
          </mat-form-field>
        </form>
      </mat-card-title>
    </mat-card-header>
    <mat-progress-bar color="primary" mode="indeterminate" [hidden]="!isLoading"></mat-progress-bar>
    <mat-card-content class="no-padding">
      <div [hidden]="isLoading || estoqueConsolidado?.data?.length === 0">
        <div>
          <table mat-table [dataSource]="estoqueConsolidado" class="table-sm">

            <!-- Filial -->
            <ng-container matColumnDef="filial">
              <th mat-header-cell *matHeaderCellDef> Filial </th>
              <td mat-cell *matCellDef="let estoqueConsolidado"> {{ estoqueConsolidado?.filial }} </td>
              <td mat-footer-cell *matFooterCellDef><Strong>Total</Strong></td>
            </ng-container>

            <!-- Modelo de Kit -->
            <ng-container matColumnDef="modeloKit">
              <th mat-header-cell *matHeaderCellDef> Modelo de KIT </th>
              <td mat-cell *matCellDef="let estoqueConsolidado"> {{ estoqueConsolidado?.modeloKit }} </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <!-- Quantidade -->
            <ng-container matColumnDef="quantidade">
              <th mat-header-cell *matHeaderCellDef> Estoque </th>
              <td mat-cell *matCellDef="let estoqueConsolidado"> {{ estoqueConsolidado?.quantidade }} </td>
              <td mat-footer-cell *matFooterCellDef><strong> {{ getQuantity() }} </strong> </td>
            </ng-container>

            <!-- Transitória -->
            <ng-container matColumnDef="transitoria">
              <th mat-header-cell *matHeaderCellDef> Transitória </th>
              <td mat-cell *matCellDef="let estoqueConsolidado"> {{estoqueConsolidado?.transitoria}} </td>
              <td mat-footer-cell *matFooterCellDef><strong> {{ getTransitory() }} </strong> </td>
            </ng-container>

            <!-- Ações -->
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef> Ação </th>
              <td mat-cell *matCellDef="let ec">
                <button mat-flat-button color="primary" (click)="openKit(ec.modeloId, { filialID: ec.filialID, descricao: ec.filial })">Detalhe</button>
              </td>
              <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
          </table>
        </div>
        <app-paginacao [pageIndex]="paging?.index"
          [pageSize]="paging?.size"
          [length]="paging?.length"
          (page)="onPageChange($event)"
          [pageSizeOptions]="[10, 20, 50]"></app-paginacao>
      </div>
      <div *ngIf="!isLoading && estoqueConsolidado?.data?.length === 0" class="d-flex justify-content-center align-items-center" style="height: 100px;">
        Nenhum registro para o período!
      </div>
    </mat-card-content>
  </mat-card>
</div>
